import { useMemo, useState } from "react";
import { animeList, categoryTabs } from "@/mocks/anime";

export default function Trending() {
  const [active, setActive] = useState("全部神番");

  const filtered = useMemo(() => {
    if (active === "全部神番") return animeList;
    return animeList.filter((a) => a.category === active);
  }, [active]);

  return (
    <section id="trending" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* heading */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
              <i className="ri-fire-fill text-lg"></i>
              热门下饭神番
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900">
              追番不踩雷，开播就上头
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              每部都是经过口碑验证的解压爆笑日常，吃饭配上一部，快乐直接拉满。
            </p>
          </div>

          {/* category tabs */}
          <div className="flex flex-wrap items-center gap-2">
            {categoryTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === tab
                    ? "bg-primary-500 text-background-50 font-bold"
                    : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {filtered.map((anime) => (
            <article
              key={anime.id}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300"
            >
              {/* cover */}
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={anime.cover}
                  alt={`${anime.title} - 小狗看番搞笑番推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 rounded-full bg-background-50/95 text-primary-700 text-xs font-bold px-2.5 py-1">
                  {anime.category}
                </span>
                <span className="absolute top-3 right-3 rounded-full bg-foreground-950/70 text-background-50 text-xs font-bold px-2.5 py-1 flex items-center gap-1">
                  <i className="ri-star-fill text-secondary-300"></i>
                  {anime.rating}
                </span>
              </div>

              {/* body */}
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 truncate">
                    {anime.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{anime.subtitle}</p>

                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {anime.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-accent-100 text-accent-800 px-2.5 py-0.5 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{anime.episodes}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-600 group-hover:translate-x-0.5 transition-transform">
                    {anime.status}
                    <i className="ri-arrow-right-s-line text-base"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}